import { create } from 'zustand';

export type TalkPanel = 'chat' | 'sessions' | 'history';

interface TalkSessionStore {
  activePanel: TalkPanel;
  threadSearch: string;
  visibleThreadCount: number;
  historySearch: string;
  visibleHistoryCount: number;
  selectedThreadIds: string[];
  renamingSessionId: string | null;
  renamingValue: string;
  setActivePanel: (value: TalkPanel) => void;
  setThreadSearch: (value: string) => void;
  setVisibleThreadCount: (value: number | ((current: number) => number)) => void;
  setHistorySearch: (value: string) => void;
  setVisibleHistoryCount: (value: number | ((current: number) => number)) => void;
  toggleSelectedThreadId: (value: string) => void;
  clearSelectedThreadIds: () => void;
  setSelectedThreadIds: (values: string[]) => void;
  setRenamingSessionId: (value: string | null) => void;
  setRenamingValue: (value: string) => void;
  resetThreadWindow: () => void;
  resetHistoryWindow: () => void;
  resetForSession: () => void;
}

const INITIAL_VISIBLE_THREADS = 20;
const INITIAL_VISIBLE_HISTORY = 20;

export const useTalkSessionStore = create<TalkSessionStore>((set) => ({
  activePanel: 'chat',
  threadSearch: '',
  visibleThreadCount: INITIAL_VISIBLE_THREADS,
  historySearch: '',
  visibleHistoryCount: INITIAL_VISIBLE_HISTORY,
  selectedThreadIds: [],
  renamingSessionId: null,
  renamingValue: '',
  setActivePanel: (value) => set({ activePanel: value }),
  setThreadSearch: (value) => set({ threadSearch: value }),
  setVisibleThreadCount: (value) => set((state) => ({
    visibleThreadCount: typeof value === 'function' ? value(state.visibleThreadCount) : value,
  })),
  setHistorySearch: (value) => set({ historySearch: value }),
  setVisibleHistoryCount: (value) => set((state) => ({
    visibleHistoryCount: typeof value === 'function' ? value(state.visibleHistoryCount) : value,
  })),
  toggleSelectedThreadId: (value) => set((state) => ({
    selectedThreadIds: state.selectedThreadIds.includes(value)
      ? state.selectedThreadIds.filter((item) => item !== value)
      : [...state.selectedThreadIds, value],
  })),
  clearSelectedThreadIds: () => set({ selectedThreadIds: [] }),
  setSelectedThreadIds: (values) => set({ selectedThreadIds: values }),
  setRenamingSessionId: (value) => set({ renamingSessionId: value }),
  setRenamingValue: (value) => set({ renamingValue: value }),
  resetThreadWindow: () => set({ visibleThreadCount: INITIAL_VISIBLE_THREADS }),
  resetHistoryWindow: () => set({ visibleHistoryCount: INITIAL_VISIBLE_HISTORY }),
  resetForSession: () => set({
    activePanel: 'chat',
    threadSearch: '',
    visibleThreadCount: INITIAL_VISIBLE_THREADS,
    historySearch: '',
    visibleHistoryCount: INITIAL_VISIBLE_HISTORY,
    selectedThreadIds: [],
    renamingSessionId: null,
    renamingValue: '',
  }),
}));
